import { steps } from "../../jsonData/data";
import styles from "./workingCycle.module.css";

export default function WorkingCycle() {
  return (
    <section
      id="our-work-flow"
      className={styles.wcRoot}
      aria-labelledby="wc-heading"
    >
      <div className={styles.wcInner}>
        <h2 id="wc-heading" className={styles.wcTitle}>
          {"Our Working Cycle"}
        </h2>
        <p className={styles.srOnly}>
          {
            "A four-step process: Discovery, Development, Deployment & Testing, Support & Maintenance, connected with arrows to show a cycle."
          }
        </p>

        <div className={styles.cardsWrap}>
          {steps.map((step) => (
            <article
              key={step.title}
              className={styles.card}
              aria-label={step.title}
            >
              <step.Icon className={styles.icon} />
              <h2 className={styles.cardTitle}>{step.title}</h2>
              <div className={styles.cardDesc}>
                {Array.isArray(step.description) ? (
                  <ul className={styles.bulletList}>
                    {step.description.map((point, index) => (
                      <li
                        key={`${step.title}-point-${index}`}
                        className={styles.bulletPoint}
                      >
                        {point.replace("• ", "")}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>{step.description}</p>
                )}
              </div>
            </article>
          ))}

          <svg
            className={`${styles.arrow} ${styles.arrowTop12}`}
            viewBox="0 0 260 80"
            aria-hidden="true"
          >
            <defs>
              <linearGradient
                id="arrowGradient1"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop offset="0%" stopColor="var(--color-primary-500)" />
                <stop offset="100%" stopColor="var(--color-white)" />
              </linearGradient>
              <marker
                id="arrowhead1"
                markerWidth="10"
                markerHeight="7"
                refX="9"
                refY="3.5"
                orient="auto"
              >
                <polygon points="0 0, 10 3.5, 0 7" fill="var(--color-white)" />
              </marker>
            </defs>
            <path
              d="M10 60 C 90 0, 170 0, 250 60"
              stroke="url(#arrowGradient1)"
              strokeWidth="3"
              fill="none"
              markerEnd="url(#arrowhead1)"
            />
          </svg>

          <svg
            className={`${styles.arrow} ${styles.arrowTop34}`}
            viewBox="0 0 260 80"
            aria-hidden="true"
          >
            <defs>
              <linearGradient
                id="arrowGradient2"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop offset="0%" stopColor="var(--color-primary-500)" />
                <stop offset="100%" stopColor="var(--color-white)" />
              </linearGradient>
              <marker
                id="arrowhead2"
                markerWidth="10"
                markerHeight="7"
                refX="9"
                refY="3.5"
                orient="auto"
              >
                <polygon points="0 0, 10 3.5, 0 7" fill="var(--color-white)" />
              </marker>
            </defs>
            <path
              d="M10 60 C 90 0, 170 0, 250 60"
              stroke="url(#arrowGradient2)"
              strokeWidth="3"
              fill="none"
              markerEnd="url(#arrowhead2)"
            />
          </svg>

          <svg
            className={`${styles.arrow} ${styles.arrowBottom23}`}
            viewBox="0 0 260 80"
            aria-hidden="true"
          >
            <defs>
              <linearGradient
                id="arrowGradient3"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop offset="0%" stopColor="var(--color-primary-500)" />
                <stop offset="100%" stopColor="var(--color-white)" />
              </linearGradient>
              <marker
                id="arrowhead3"
                markerWidth="10"
                markerHeight="7"
                refX="9"
                refY="3.5"
                orient="auto"
              >
                <polygon points="0 0, 10 3.5, 0 7" fill="var(--color-white)" />
              </marker>
            </defs>
            <path
              d="M10 20 C 90 80, 170 80, 250 20"
              stroke="url(#arrowGradient3)"
              strokeWidth="3"
              fill="none"
              markerEnd="url(#arrowhead3)"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}
